<template>
    <div class="listmain "> 
        <h1 class="firTitle">技能发布</h1>
              
              <h3 class="sedTitle">1、概述</h3>
              <p>技能发布后将进入技能商店，终端设备可以通过添加技能暴露给用户
              </p>
              <h3 class="sedTitle">2、前置条件</h3>
              <p>技能发布需要经过开发者认证，只有认证通过的开发者才能发布技能。
              </p>
               <h3 class="sedTitle">3、发布上线</h3>
              <p>填写相关申请材料后点击发布上线，技能发布上线后，进入审核中状态。
              </p>
             
                <table>
                <tr>
                  <th >字段名称</th>
                  <th>释义</th>
                   <th>是否必填</th>
                  <th>备注</th>
                
                </tr>
                <tr>
                  <td>版本号</td>
                  <td>标记当前技能的版本号，必须为整数且唯一</td>
                    <td>是</td>
                  <td>必填且不可与历史版本重复</td>
                
                </tr>
                <tr>
                  <td>表达示例</td>
                  <td>填充用户端query调起技能的示例，最多填充三个且不允许有特殊字符</td>
                   <td>是</td>
                  <td>在用户端会以语音的形式播报出来</td>
                  
                </tr>
                 <tr>
                  <td>版本说明</td>
                  <td>填充技能更新的相关信息</td>
                  <td>是</td>
                  <td>技能更新信息</td>

                </tr>
               
              </table>
 <h3 class="sedTitle">4、版本管理</h3>
              <p>审核：审核期间内容不可编辑，3~5日后消息通知中收到审核结果。<br>
              撤回：发布申请从运营中心中删除，状态从审核中状态回到开发中状态。<br>
              线上：技能发布并审核通过后，将会在技能商店中呈现。线上技能不可编辑。<br>
              更新：用户点击更新后，将会创建一个开发中副本，用户可在当前线上版本的基础上进行开发
              </p>
               <h3 class="sedTitle">5、审核</h3>
              <p>技能发布后会提交到开放平台运营中心进行审核，3~5天内审核结果会在消息中心中进行通知，通过审核后的技能将在技能商店中进行展示
              </p>
    </div>
</template>

<script>
export default {
  name: ""
};
</script>

<style  rel="stylesheet/scss" lang="scss" scoped>
h1,
h2,
h3,
h4,
h5 {
  padding: 0;
  margin: 0px;
  font-weight: normal;
}

ul,
li {
  list-style: none;
}

.listmain {
  font-size: 14px;
  line-height: 26px;
  .firTitle {
    font-size: 20px;
    color: #1e4d79;
    margin-bottom: 30px;
  }
  .sedTitle {
    font-size: 16px;
    font-weight: bold;
    padding-bottom: 10px;
    border-bottom: 1px solid #f3f3f3;
    margin-bottom: 15px;
    margin-top: 50px;
    &.fir {
      margin-top: 0px;
    }
  }
  .thirdTitle {
    margin-top: 50px;
    font-weight: bold;
    line-height: 26px;
    font-size: 14px;
  }
  .codeTitle {
    font-weight: bold;
    line-height: 26px;
  }
  pre {
    margin-top: 20px;
  }
  img {
    margin: 30px 0;
  }
  table,
  table tr th,
  table tr td {
    border: 1px solid #000;
    text-align: center;
  }
  table {
    line-height: 30px;
    width: 100%;
    border-collapse: collapse;
    margin: 10px 0;
  }
}

.el-submenu .el-menu-item {
  min-width: 190px;
  background: #f5f5f5;
}

.el-submenu {
  min-width: 190px;
  background: #f5f5f5;
}

img {
  margin-top: 30px;
  margin-bottom: 30px;
}
</style>




// WEBPACK FOOTER //
// src/components/tutor/jnfb.vue